import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Hero() {
  return <section className="relative min-h-screen w-full bg-white text-black overflow-hidden flex items-center justify-center pt-20 pb-20" data-id="element-99">
      {/* Geometric Background Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-600 opacity-5 -skew-x-12 transform origin-top-right translate-x-1/4" data-id="element-100" />
      <div className="absolute bottom-0 left-0 w-64 h-64 border-4 border-slate-600 transform rotate-45 -translate-x-1/2 translate-y-1/2" data-id="element-101" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full" data-id="element-102">
        <div className="flex flex-col items-start max-w-4xl" data-id="element-103">
          <div className="mb-6 inline-block bg-slate-600 px-4 py-1 transform -skew-x-12" data-id="element-104">
            <span className="block transform skew-x-12 font-bold tracking-wider uppercase text-sm text-white" data-id="element-105">
              Real Estate Solutions
            </span>
          </div>

          <h1 className="text-6xl md:text-7xl lg:text-9xl font-black tracking-tighter leading-[0.9] mb-8 text-black" data-id="element-106">
            WE BUY <br data-id="element-107" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-black to-gray-500" data-id="element-108">
              HOUSES.
            </span>{' '}
            <br data-id="element-109" />
            <span className="text-slate-600" data-id="element-110">FAST.</span> FAIR.
          </h1>

          <p className="text-xl md:text-2xl font-medium text-gray-700 max-w-2xl mb-12 leading-relaxed" data-id="element-111">
            Skip the agents. Skip the repairs. Skip the fees. We provide instant
            cash offers for properties nationwide.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-112">
            <Link to="/get-offer" className="group relative bg-slate-600 text-white px-8 py-5 text-lg font-bold tracking-wide overflow-hidden transition-transform hover:scale-105 active:scale-95 flex items-center justify-center gap-2" data-id="element-113">
              <span className="relative z-10 flex items-center gap-2" data-id="element-114">
                GET YOUR CASH OFFER
                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-115" />
              </span>
            </Link>

            <Link to="/about" className="group px-8 py-5 text-lg font-bold tracking-wide border-2 border-black text-black hover:bg-black hover:text-white transition-colors text-center" data-id="element-116">
              HOW IT WORKS
            </Link>
          </div>
        </div>
      </div>

      {/* Diagonal Divider */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gray-50" style={{
      clipPath: 'polygon(0 100%, 100% 100%, 100% 0)'
    }} data-id="element-117"></div>
    </section>;
}